module.exports = __webpack_public_path__ + "static/media/terms_es.484c858a.txt";